// 編集中ロック。対象画面では EnsureEditLock ミドルウェアが layouts/edit-lock.blade.php 経由で
// window.__EDIT_LOCK__ を注入する。編集モードならハートビートで延命し、閲覧のみモードなら入力を無効化する。

const lock = window.__EDIT_LOCK__;

if (lock) {
    if (lock.readOnly) {
        applyReadOnly();
    } else {
        startHeartbeat(lock);
    }
}

// .app__content 内の操作系要素を無効化する。Alpine が後から描画するノードも
// MutationObserver で追従して無効化する（x-for の行追加ボタン等）。
function applyReadOnly() {
    const root = document.querySelector('.app__content');
    if (!root) return;

    const disableAll = () => {
        root.querySelectorAll('input, select, textarea, button').forEach((el) => {
            if (!el.closest('[data-lock-exempt]')) el.disabled = true;
        });
    };
    disableAll();
    new MutationObserver(disableAll).observe(root, { childList: true, subtree: true });

    document.addEventListener('submit', (e) => {
        // data-lock-exempt のフォーム（提出済みバナーの「編集許可をリクエスト」等）は送信を許可する
        if (root.contains(e.target) && !e.target.closest('[data-lock-exempt]')) e.preventDefault();
    }, true);
}

function startHeartbeat({ key, token, interval, heartbeatUrl, releaseUrl }) {
    let timer = null;
    const stop = () => { if (timer) clearInterval(timer); timer = null; };

    const send = async () => {
        try {
            const res = await fetch(heartbeatUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content ?? '',
                },
                body: JSON.stringify({ key, token }),
                keepalive: true,
            });
            if (res.redirected) { stop(); showBanner('セッションが切れました。再ログインしてください。'); return; }
            if (!res.ok) return; // 一時的なエラーは次回のハートビートに任せる
            const data = await res.json();
            if (!data.ok) {
                // ロックが他のユーザーへ渡っていた（PCスリープ等で失効した後など）
                stop();
                window.__EDIT_LOCK__.readOnly = true;
                showBanner(`${data.holder ?? '他のユーザー'}さんが編集中です。閲覧のみ可能です（変更は保存できません）。`);
                applyReadOnly();
            }
        } catch {
            // オフライン等。次回のハートビートに任せる
        }
    };

    timer = setInterval(send, (interval || 30) * 1000);

    // 画面を離れたら即解放（token 不一致なら server 側で no-op）
    window.addEventListener('pagehide', () => {
        const data = new FormData();
        data.append('key', key);
        data.append('token', token);
        navigator.sendBeacon(releaseUrl, data);
    });

    // bfcache 復帰（戻るボタン）時は解放済みの可能性があるため即時ハートビートで取得し直す
    window.addEventListener('pageshow', (e) => { if (e.persisted) send(); });
}

function showBanner(message) {
    const existing = document.querySelector('[data-edit-lock-banner]');
    if (existing) { existing.textContent = message; return; }
    const banner = document.createElement('div');
    banner.className = 'flash flash--error';
    banner.setAttribute('data-edit-lock-banner', '');
    banner.textContent = message;
    document.querySelector('.app__content')?.prepend(banner);
}
